import * as Yup from 'yup';

/**
 * Schema: propertySchema
 *
 * This schema defines the validation rules for a property object using Yup.
 *
 * @property {string} creationType - The creation type (required).
 * @property {string} generatorType - The generator type (required).
 * @property {Object} options - The options object containing elements.
 * @property {Array|string} options.elements - The elements which can be either a string or an array (required).
 */
const propertySchema = Yup.object().shape({
  creationType: Yup.string().required('Creation type is required'),
  generatorType: Yup.string().required('Generator type is required'),
  options: Yup.object()
    .shape({
      elements: Yup.mixed()
        .test(
          'is-array-or-string',
          'This type must have a value',
          (value) => typeof value === 'string' || Array.isArray(value)
        )
        .required('Elements are required'),
    })
    .required('Options are required'),
});

/**
 * Schema: buildingComponentSchema
 *
 * This schema defines the validation rules for a building component object using Yup.
 *
 * @property {Object} wallInterior - The wall interior property (required).
 * @property {Object} wallExterior - The wall exterior property (required).
 * @property {Object} floor - The floor property (required).
 * @property {Object} floorGround - The floor ground property (required).
 * @property {Object} windowType - The window type property (required).
 * @property {Object} roof - The roof property (required).
 */
const buildingComponentSchema = Yup.object().shape({
  wallInterior: propertySchema.required('Wall interior is required'),
  wallExterior: propertySchema.required('Wall exterior is required'),
  floor: propertySchema.required('Floor is required'),
  floorGround: propertySchema.required('Floor ground is required'),
  windowType: propertySchema.required('Window type is required'),
  roof: propertySchema.required('Roof is required'),
});

export default buildingComponentSchema;
